export const ENROLL_PRODUCT_TYPES = {
  COURSE: 'course',
  SPECIALIZATION: 's12n',
};
